import Swiper from 'swiper';
import '../css/common/common.css';
import '../css/common/content-wrapper.css';
import '../css/common/banner-wrapper.css';
import '../css/common/pattern-cover.css';
import '../css/common/section-block.css';

import '../css/facilities/facility-section.css';
import '../css/facilities/info-block.css';
import '../css/facilities/floor-block.css';
import '../css/facilities/floor-cell.css';
import '../css/facilities/floor-item.css';

import '../../node_modules/swiper/dist/css/swiper.css';
import '../css/swiper-container.css';

import '../js/importCommonCss';
import setup from './setupCommonJS';
import renderFacility from './facilities/renderFacility';
import renderService from './facilities/renderService';
import getWordingJson from './request/wordingJson';
import getFacilityPage from './request/facilityList';
import wordingSetter from './wordingSetter';
import scrollToAnchor from './scrollToAnchor';
import hideLoadingImage from './common/hideLoadingImage';

setup();

const wordingJsonPromise = getWordingJson('facility')
	.then((json) => wordingSetter(json));

const facilityPagePromise = getFacilityPage()
	.then((json) => {
		renderFacility(json.facilities);
		renderService(json.services);

		Swiper('.swiper-container', {
			pagination: '.swiper-pagination',
			nextButton: '.swiper-button-next',
			prevButton: '.swiper-button-prev',
			slidesPerView: 1,
			paginationClickable: true,
			spaceBetween: 30,
			loop: true,
		});
	});

/**
 * make sure each promise is finished
 */
Promise.all([wordingJsonPromise, facilityPagePromise])
	.then(() => hideLoadingImage())
	.then(() => {
		scrollToAnchor(window.location.hash);
	});



// WEBPACK FOOTER //
// ./src/js/facilities.js